const prefix = ''

export const loginHistoryUrls = {
  'loginHistory.list': `${prefix}/login-history`,
}
